import { AfterViewInit, Component} from '@angular/core';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.css'],
    standalone: false
})
export class HistoryComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
      window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "History" }));
  }
}
